export default "__VITE_ASSET__D7zlR4D8__"